// Entry imports
const AuthModalActions = require('client-v2/common/containers/auth-modal/actions-component')
const BottomCallToActionSection = require('./component-dumb')

module.exports = AuthModalActions(BottomCallToActionSection)
